import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { IPropertyCard } from '../../../../shared/models/propertycard';
import { PropertyManagementService } from '../../../../shared/providers/property-management.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { RestService } from '../../../../shared/providers/rest.service';
import { IResponseModel } from '../../../../shared/models/ResponseModel';
import { MultipleEmailIdModel } from '../../../../shared/models/MultipleEmailIdModel';

interface ISharedList {
    PropertyId: number;
    PropertyName: string;
    FullAddress: string;
    PropertyStatus: string;
}

interface IShareListing {
    EmailForShare: string[];
    GroupId?: number;
    GroupName: string;
    SharedUserId: number;
    CreatedDate: Date;
    ExpiryDate: Date;
    Properties: IShareListingProperties[];
}

interface IShareListingProperties {
    Id: number;
    TenantName: string;
    CityName: string;
    StateCode: string;
    Price: number;
    CapRate: string;
    RemainingTerm: string;
    LeaseExpiration?: Date;
    LeaseCommencementDate?: Date;
}

interface IGroupDetails {
    GroupId: number;
    GroupName: string;
    ExpiryDate: Date;
}

@Component({
    selector: 'app-share-group-add',
    templateUrl: './share-group-add.component.html'
})
export class ShareGroupAddComponent implements OnInit {

    constructor(protected loaderService: LoaderService, public Validation: ValidationService, private _propertyManagementService: PropertyManagementService, private _toastService: ToastService, public authService: AuthenticationService, private _restService: RestService) {
        //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/common/principalForShareListingByAutoComplete/', 'Email', 'Email');
        //remoteDataProvider.urlFormater(x => {
        //    return encodeURI(_restService.getBaseUrl + '/common/principalForShareListingByAutoComplete/' + x);
        //});
        //this.dataService = remoteDataProvider;
    }

    user: any;
    keyCode: number[];
    sharedList: ISharedList[];
    response = {} as IResponseModel;
    shareListing = {} as IShareListing;
    shareUserName: string = null;
    isShareSubmit = false;
    mailIds: MultipleEmailIdModel[];
    isShareMode = false;

    @Input() selectedProperties: IPropertyCard[];
    @Input() modalRefShareListing: BsModalRef;
    @Input() GroupDetails = {} as IGroupDetails;
    @Output() removeProperties = new EventEmitter();
    @Output() reloadList = new EventEmitter();

    ngOnInit() {
        this.user = this.authService.user;
        this.shareListing = {} as IShareListing;
        this.isShareSubmit = false;
        this.shareListing.EmailForShare = [];
        this.mailIds = [];
        this.keyCode = [32, 188, 13];
        this.sharedList = [];

        if (this.Validation.IsinValid(this.GroupDetails.GroupId)) {
            this.isShareMode = false;
            this.selectedProperties.forEach(item => {
                const property =
                    {
                        PropertyId: item.Id,
                        PropertyName: item.PropertyName,
                        FullAddress: item.FullAddress,
                        PropertyStatus: item.PropertyStatus
                    }
                this.sharedList.push(property);
            });
            this.shareListing.ExpiryDate = this.Validation.convertUTCDateToLocalDate(this.Validation.addDays(new Date(), 15));
        }
        else {
            this.isShareMode = true;
            this.shareListing.GroupId = this.GroupDetails.GroupId;
            this.shareListing.GroupName = this.GroupDetails.GroupName;
            this.shareListing.ExpiryDate = this.Validation.convertUTCDateToLocalDate(this.GroupDetails.ExpiryDate);
            this.shareListing.SharedUserId = this.user.Id;

            this._propertyManagementService.GetSharedPropertiesUnderGroup(this.shareListing.GroupId).subscribe(res => {
                this.shareListing.Properties = res;
                this.shareListing.Properties.forEach(item => {
                    item.RemainingTerm = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
                });
            });
        }
    }

    shareList() {
        this.isShareSubmit = true;
        let valid = true;
        if (this.mailIds.length == 0) {
            valid = false;
        }
        else if (this.Validation.IsinValid(this.shareListing.GroupName)) {
            valid = false;
        }
        else if (this.Validation.IsinValid(this.shareListing.ExpiryDate)) {
            valid = false;
        }

        if (valid) {
            this.loaderService.display(true);
            this.shareListing.EmailForShare = this.mailIds.map(function (data) { return data.value });
            this.shareListing.SharedUserId = this.user.Id;
            this.shareListing.CreatedDate = this.Validation.utcify(new Date());
            this.shareListing.ExpiryDate = this.Validation.utcify(this.shareListing.ExpiryDate);
         
            if (!this.isShareMode) {
                this.shareListing.Properties = [];
                this.shareListing.GroupId = null;
                let properties: IShareListingProperties[];
                properties = [];
                let selected = this.selectedProperties.filter(x => x.IsSelected == true);
                selected.forEach(item => {
                    const prop =
                        {
                            Id: item.Id,
                            TenantName: item.PropertyName,
                            CityName: item.City,
                            StateCode: item.State,
                            Price: item.Price,
                            CapRate: item.CapRate,
                            RemainingTerm: item.Remaining_Term
                        }
                    properties.push(prop);

                });
                this.shareListing.Properties = properties;
            }
            this._propertyManagementService.ShareListing(this.shareListing).subscribe(res => {
                this.response = res;
                if (this.response.IsSuccess) {
                    this._toastService.addToast({
                        title: 'Success',
                        msg: 'Property shared successfully',
                      timeout: 5000,
                        theme: 'bootstrap',
                        position: 'bottom-right',
                        type: 'success'
                    });
                    this.modalRefShareListing.hide();
                    if (!this.isShareMode) {
                        this.selectedProperties.forEach(item => {
                            item.IsSelected = false;
                        });
                        this.removeProperties.emit(0);
                    }
                    else {
                        this.reloadList.emit(true);
                    }
                }
                else {
                    this._toastService.addToast({ title: 'Error Occurred', msg: this.response.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
                }
                this.loaderService.display(false);
            });
        }
    }

    removeProperty(propertyId: number, index: number) {
        let prop = this.selectedProperties.find(x => x.Id == propertyId);
        prop.IsSelected = false;
        this.sharedList.splice(index, 1);
        this.removeProperties.emit(propertyId);
    }

    public validators = [this.validEmail$];

    public errorMessages = {
        'validEmail$': 'Invalid Email Address'
    };

    validEmail$(control: any) {

        if (control.value != "") {
            let serchfind: boolean;
            const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            serchfind = regexp.test(control.value);
            if (serchfind == false) {
                return {
                    'validEmail$': true
                };
            }
        }

        return null;
    }
}
